import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import * as EnumFormaDoruceni from "../api/gen/cgo/EnumFormaDoruceni";
import * as EnumFormaDoruceniInfo from "../api/EnumFormaDoruceniInfo";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

const {Form, FormBody, FormActions} = form;

/**
 * Formulář pro tvorbu/úpravu způsobů dopravy.
 */
class ZpusobDopravyForm extends Component<WithTranslation> {

    static formName = 'ZpusobDopravyForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.Name')} name="nazevDoprava" required disabled={submitting}/>
                <ff.ObjectSuggest
                    label={t('labels.delivery_form')}
                    name="formaDoruceni"
                    dropdown={true}
                    removable={false}
                    getItemValue={(item) => item ? EnumFormaDoruceniInfo.getCaption(item, t) : ""}
                    renderSuggestion={item => item ? EnumFormaDoruceniInfo.getCaption(item, t) : ""}
                    items={EnumFormaDoruceni.values}
                    required
                />
                <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: ZpusobDopravyForm.formName,
})(ZpusobDopravyForm)));
